import { resolvePaymentMethodIcon } from '../../../GestionTransferts/Reservations/transferPaymentMethodIcon'
import PaymentMethodFields from './PaymentMethodFields'

const money = (value, currency, displayAmount) =>
  `${Number(displayAmount(value) || 0).toFixed(2)} ${currency}`

const TamarraNote = ({ kind = 'info', children }) => {
  if (!children) return null
  return (
    <div
      className={`tamarra-banner${kind === 'warn' ? ' tamarra-banner-warn' : kind === 'err' ? ' tamarra-banner-err' : ''}`}
      role="status"
    >
      {children}
    </div>
  )
}

const TamarraDebtorDepositUi = ({
  t,
  loading,
  disabled,
  error,
  fallbackMode,
  hideManual,
  lockPaymentAmount,
  lockPaymentAmountMessage,
  partnerDisplay,
  displayAmount,
  displayToTnd,
  displayCurrency,
  totalAmount,
  totalCalculated,
  totalOk,
  labels,
  paymentMethods,
  availableMethods,
  orderedMethods,
  partnerModesById,
  manualMethodIdsForDropdown,
  balanceDisplay,
  balanceInfo,
  creditNotice,
  showFallbackNotice,
  showIncompleteNotice,
  updatePaymentMethod,
  updateManualPaymentMethodAmount,
  updateManualPaymentMethodFields,
  changeManualPaymentMethodType,
  selectManualPaymentMethod,
  addManualPaymentMethod,
  removeManualPaymentMethod,
  extractAmount,
  getMaxAmountForMethod,
  getPaymentValidation,
}) => {
  if (loading) {
    return (
      <div className="tamarra-pay">
        <h4 className="tamarra-grp">{t('transferts.reservations.payment.debtorDeposit')}</h4>
        <p className="tamarra-bk-rate">
          {t('moteurReservation.automaticPaymentMethods.loading_payment_methods')}
        </p>
      </div>
    )
  }

  const autoTypes =
    Object.keys(paymentMethods).length > 0
      ? Object.keys(paymentMethods)
      : availableMethods.length > 0
        ? availableMethods
        : ['debiteur', 'deposit', 'totalite_en_ligne', 'total_marge']

  const plafondLabel =
    partnerDisplay && balanceInfo?.plafond != null
      ? money(balanceInfo.plafond.availableAmount || 0, displayCurrency, displayAmount)
      : balanceDisplay?.plafond?.formatted?.available
  const depositLabel =
    partnerDisplay && balanceInfo?.deposit != null
      ? money(balanceInfo.deposit.availableAmount || 0, displayCurrency, displayAmount)
      : balanceDisplay?.deposit?.formatted?.available

  return (
    <div className="tamarra-pay tamarra-debtor-ui">
      <h4 className="tamarra-grp">
        {hideManual
          ? t('moteurReservation.automaticPaymentMethods.payment_methods_title')
          : fallbackMode
            ? t('moteurReservation.automaticPaymentMethods.manual_payment_methods_title')
            : t('transferts.reservations.payment.debtorDeposit')}
      </h4>

      {creditNotice}

      {showFallbackNotice ? (
        <TamarraNote kind="warn">
          {t('moteurReservation.automaticPaymentMethods.no_payment_method_configuration_found')}
        </TamarraNote>
      ) : null}

      {error ? <TamarraNote kind="err">{error}</TamarraNote> : null}

      {showIncompleteNotice ? (
        <TamarraNote kind="warn">
          {t('moteurReservation.automaticPaymentMethods.no_valid_payment_method_configured')}
        </TamarraNote>
      ) : null}

      {balanceDisplay ? (
        <div className="tamarra-avail">
          <span className="tamarra-label">
            {t('moteurReservation.automaticPaymentMethods.balance_info_title')}
          </span>
          {balanceDisplay.plafond ? (
            <span className={`tamarra-chip ${balanceDisplay.plafond.isValid ? 'ok' : 'warn'}`}>
              {t('moteurReservation.automaticPaymentMethods.plafond')} : {plafondLabel}
            </span>
          ) : null}
          {balanceDisplay.deposit ? (
            <span className={`tamarra-chip ${balanceDisplay.deposit.isValid ? 'ok' : 'warn'}`}>
              {t('moteurReservation.automaticPaymentMethods.deposit')} : {depositLabel}
            </span>
          ) : null}
        </div>
      ) : null}

      {orderedMethods.length === 1 ? (
        <p className="tamarra-bk-rate">
          {t('moteurReservation.automaticPaymentMethods.info_description')}
        </p>
      ) : null}

      {lockPaymentAmount && lockPaymentAmountMessage ? (
        <TamarraNote>{lockPaymentAmountMessage}</TamarraNote>
      ) : null}

      <div className="tamarra-recap">
        <div className="tamarra-r">
          <span>{t('moteurReservation.automaticPaymentMethods.total_amount')}</span>
          <span>{money(totalAmount, displayCurrency, displayAmount)}</span>
        </div>
        <div className={`tamarra-r tamarra-rt${totalOk ? '' : ' tamarra-r-bad'}`}>
          <span>{t('moteurReservation.automaticPaymentMethods.total_entered')}</span>
          <span>{money(totalCalculated, displayCurrency, displayAmount)}</span>
        </div>
        {!totalOk ? (
          <div className="tamarra-r">
            <span>{t('moteurReservation.automaticPaymentMethods.difference')}</span>
            <span>{money(totalAmount - totalCalculated, displayCurrency, displayAmount)}</span>
          </div>
        ) : null}
      </div>

      {!hideManual && !fallbackMode ? (
        <div className="tamarra-choices tamarra-debtor-list">
          {autoTypes.map((methodType, index) => {
            const method = orderedMethods.find((row) => row.type === methodType) || {
              type: methodType,
              order: index + 1,
            }
            const methodAmount = paymentMethods[methodType] || 0
            const on = Number(methodAmount) > 0
            const inputValue = partnerDisplay
              ? methodAmount === '' || methodAmount == null
                ? ''
                : displayAmount(methodAmount)
              : methodAmount
            return (
              <div className={`tamarra-choice tamarra-debtor-card${on ? ' on' : ''}`} key={methodType}>
                <div className="tamarra-debtor-copy">
                  <b>
                    {t('moteurReservation.automaticPaymentMethods.method_order', {
                      order: method.order,
                    })}
                    {' · '}
                    {labels[methodType] || methodType}
                  </b>
                  <small>
                    {t('moteurReservation.automaticPaymentMethods.automatic')}
                    {index > 0 && methodAmount > 0
                      ? ` · ${t('moteurReservation.automaticPaymentMethods.automatic_split')}`
                      : ''}
                  </small>
                </div>
                <label className="tamarra-pf tamarra-pf-amount">
                  <span>
                    {partnerDisplay
                      ? `Montant (${displayCurrency})`
                      : t('moteurReservation.automaticPaymentMethods.amount_label')}
                  </span>
                  <input
                    type="number"
                    min={0}
                    max={partnerDisplay ? displayAmount(totalAmount) : totalAmount}
                    step="0.01"
                    value={inputValue}
                    disabled={disabled || lockPaymentAmount || (index > 0 && methodAmount === 0)}
                    readOnly={lockPaymentAmount}
                    aria-readonly={lockPaymentAmount ? 'true' : undefined}
                    onChange={(e) => {
                      if (lockPaymentAmount) return
                      const raw = e.target.value
                      const valueTnd = raw === '' ? '' : displayToTnd(raw)
                      updatePaymentMethod(methodType, valueTnd)
                    }}
                  />
                  {getPaymentValidation(methodType, methodAmount)}
                </label>
              </div>
            )
          })}
        </div>
      ) : null}

      {!hideManual && fallbackMode ? (
        <>
          <h4 className="tamarra-grp">
            {t('tamarraBooking.payment.methodTitle', { defaultValue: 'Mode de paiement' })}
          </h4>
          <p className="tamarra-bk-rate">
            {t('moteurReservation.automaticPaymentMethods.multi_hint', {
              defaultValue:
                'Ajoutez un ou plusieurs modes. La somme des montants doit égaler le total à payer.',
            })}
          </p>
          <div
            className="tamarra-pay-tiles"
            role="group"
            aria-label={t('moteurReservation.reservationModal.paymentMethod', {
              defaultValue: 'Mode de paiement',
            })}
          >
            {(manualMethodIdsForDropdown?.length
              ? manualMethodIdsForDropdown
              : availableMethods
            ).map((methodType) => {
              const title = labels[methodType] || methodType
              const Icon = resolvePaymentMethodIcon(
                partnerModesById?.[methodType] || { name: title, label: title },
                title,
              )
              const selected = Object.prototype.hasOwnProperty.call(paymentMethods, methodType)
              return (
                <button
                  key={methodType}
                  type="button"
                  className={`tamarra-pay-tile${selected ? ' on' : ''}${disabled ? ' off' : ''}`}
                  disabled={disabled || selected}
                  aria-pressed={selected}
                  onClick={() => {
                    if (selected || disabled) return
                    selectManualPaymentMethod?.(methodType)
                  }}
                >
                  <span className="tamarra-pay-tile-ico" aria-hidden="true">
                    <Icon />
                  </span>
                  <b>{title}</b>
                </button>
              )
            })}
          </div>

          {Object.entries(paymentMethods).map(([methodType, paymentValue]) => {
            const amt = extractAmount(paymentValue)
            const title = labels[methodType] || methodType
            const maxTnd =
              typeof getMaxAmountForMethod === 'function'
                ? getMaxAmountForMethod(methodType)
                : totalAmount
            const maxInput = partnerDisplay ? displayAmount(maxTnd) : maxTnd
            return (
              <div className="tamarra-pay-box" key={methodType}>
                <div className="tamarra-debtor-manual-h">
                  <b>{title}</b>
                  <button
                    type="button"
                    className="tamarra-linkbtn"
                    disabled={disabled}
                    onClick={() => removeManualPaymentMethod(methodType)}
                  >
                    {t('tamarraBooking.circuit.removeRoom', { defaultValue: 'Retirer' })}
                  </button>
                </div>
                {partnerModesById?.[methodType] ? (
                  <>
                    <PaymentMethodFields
                      paymentMethod={partnerModesById[methodType]}
                      fieldValues={
                        typeof paymentValue === 'object' && paymentValue?.fields
                          ? paymentValue.fields
                          : {}
                      }
                      onFieldChange={(fields) =>
                        updateManualPaymentMethodFields(methodType, fields)
                      }
                      disabled={disabled}
                      amount={amt}
                      amountMax={maxInput}
                      amountReadOnly={lockPaymentAmount}
                      onAmountChange={(next) => {
                        if (lockPaymentAmount) return
                        const valueTnd = partnerDisplay ? displayToTnd(next) : next
                        updateManualPaymentMethodAmount(methodType, valueTnd)
                      }}
                      requireAmount={false}
                      variant="tamarra"
                      displayCurrency={displayCurrency}
                      displayAmount={displayAmount}
                    />
                    {getPaymentValidation(methodType, amt)}
                  </>
                ) : (
                  <div className="tamarra-pay-extra-g">
                    <label className="tamarra-pf">
                      <span>
                        {partnerDisplay
                          ? `Montant (${displayCurrency})`
                          : t('moteurReservation.automaticPaymentMethods.amount_label')}
                      </span>
                      <input
                        type="number"
                        min={0}
                        max={maxInput}
                        step="0.01"
                        value={partnerDisplay ? displayAmount(amt) : amt}
                        disabled={disabled || lockPaymentAmount}
                        readOnly={lockPaymentAmount}
                        aria-readonly={lockPaymentAmount ? 'true' : undefined}
                        onChange={(e) => {
                          if (lockPaymentAmount) return
                          const raw = e.target.value
                          if (raw === '') {
                            updateManualPaymentMethodAmount(methodType, 0)
                            return
                          }
                          const valueTnd = displayToTnd(raw)
                          updateManualPaymentMethodAmount(methodType, valueTnd)
                        }}
                      />
                      {getPaymentValidation(methodType, amt)}
                    </label>
                  </div>
                )}
              </div>
            )
          })}
        </>
      ) : null}

      {orderedMethods.length === 0 && !fallbackMode && !hideManual ? (
        <p className="tamarra-bk-rate">
          {t('moteurReservation.automaticPaymentMethods.no_payment_method_configured')}
        </p>
      ) : null}

      {Object.keys(paymentMethods).length === 0 && fallbackMode && !hideManual ? (
        <p className="tamarra-bk-rate">
          {t('moteurReservation.automaticPaymentMethods.no_payment_method_added')}
        </p>
      ) : null}
    </div>
  )
}

export default TamarraDebtorDepositUi
